<template>
  <div class="layerItem">
    <appRectangle :item="completeItem" :index="index" :updateItem="updateItem">
    </appRectangle>
    <appItemHelperline
      :item="completeItem"
      :index="index"
      :orientation="'vertical'"
    ></appItemHelperline>
    <appItemHelperline
      :item="completeItem"
      :index="index"
      :orientation="'horizontal'"
    ></appItemHelperline>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import * as R from "ramda";
import Rectangle from "./Rectangle";
import ItemHelperline from "./ItemHelperline";

export default {
  components: {
    appRectangle: Rectangle,
    appItemHelperline: ItemHelperline
  },
  props: ["item", "index", "updateItem", "defaultItemProps"],
  computed: {
    completeItem: function () {
      return { ...this.defaultItemProps, ...this.item };
    }
  },
  methods: {}
};
</script>
